import { useUIStore } from './store';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AuthGuard } from './components/AuthGuard';
import { NetworkStatus } from './components/NetworkStatus';
import { Dashboard } from './components/Dashboard';
import { PaymentFlow } from './components/PaymentFlow';
import { PaymentHistory } from './components/PaymentHistory';

const AppContent = () => {
  const { activeView } = useUIStore();

  const renderActiveView = () => {
    switch (activeView) {
      case 'dashboard':
        return <Dashboard />;
      case 'payment':
        return <PaymentFlow />;
      case 'history':
        return <PaymentHistory />;
      case 'error':
        return (
          <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="text-center">
              <div className="text-6xl mb-4">⚠️</div>
              <h2 className="text-xl font-semibold text-red-600 mb-2">
                Application Error
              </h2>
              <p className="text-gray-600">
                Something went wrong. Please close and reopen the app.
              </p>
            </div>
          </div>
        );
      default:
        return <Dashboard />;
    }
  };

  return (
    <>
      <NetworkStatus />
      <div className="min-h-screen bg-gray-50">
        {renderActiveView()}
      </div>
    </>
  );
};

const App = () => {
  return (
    <ErrorBoundary>
      <AuthGuard>
        <AppContent />
      </AuthGuard>
    </ErrorBoundary>
  );
};

export default App;